import { render, staticRenderFns } from "./CardConnection.vue?vue&type=template&id=367c7920&scoped=true"
import script from "./CardConnection.vue?vue&type=script&lang=js"
export * from "./CardConnection.vue?vue&type=script&lang=js"
import style0 from "./CardConnection.vue?vue&type=style&index=0&id=367c7920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c7920",
  null
  
)

export default component.exports